import { createActionGroup, props } from '@ngrx/store';
import type { Dealer, VehicleMarketDealer } from '../../api/api-types';

export const actions = createActionGroup({
    source: 'dealer',
    events: {
        'Load Dealer By Slug': props<{ slug: string }>(),
        'Load Dealer By Slug Success': props<{ dealer: Dealer }>(),
        'Load Dealer By Slug Failure': props<{ error: string }>(),

        'Load Vehicle Market Dealer By Slug': props<{ slug: string }>(),
        'Load Vehicle Market Dealer By Slug Success': props<{ dealer: VehicleMarketDealer }>(),
        'Load Vehicle Market Dealer By Slug Failure': props<{ error: string }>(),
    },
});
